import React from "react";
import { IMAGES } from "../mock";
import Reveal from "./ui/Reveal";

export default function Formatore() {
  return (
    <section id="formatore" className="py-24 lg:py-36 bg-[#0c0c0c] border-y border-white/5">
      <div className="container-max">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          <Reveal variant="fade-left" className="lg:col-span-5">
            <div className="relative rounded-2xl overflow-hidden border border-white/10 aspect-[4/5]">
              <img
                src="/francesco-formatore-bw-neon.jpg"
                alt="Frank Gheri"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-black/20" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent" />
              <div className="absolute bottom-6 left-6 right-6">
                <div className="font-mono-label text-white/60 text-[11px]">Sessioni tenute da</div>
                <div className="font-display text-3xl lg:text-4xl text-white mt-2">Frank Gheri</div>
              </div>
            </div>
          </Reveal>

          <div className="lg:col-span-7">
            <span className="section-label">Il formatore</span>
            <Reveal variant="zoom" as="h2" className="font-display text-4xl lg:text-5xl text-white mt-6 leading-tight">
              Imprenditore Digitale,<br />
              <span className="italic font-light text-white/60">Funnel Manager & Formatore.</span>
            </Reveal>
            <Reveal variant="fade-right" delay={200} className="mt-8 space-y-5 text-white/75 text-base lg:text-lg leading-relaxed">
              <p className="text-white text-lg font-medium">Credo nella forza dell’imprenditore che sceglie di evolversi.</p>
              <p>
                Che non delega alla cieca, ma si prende il controllo. Che trasforma ogni ostacolo digitale in
                un’opportunità concreta.
              </p>
              <p>
                Con <span className="text-white font-medium">Digital Formula</span> ho aiutato decine di business
                a costruire ecosistemi solidi, misurabili, scalabili. Con <span className="text-white font-medium">My Digital Action — Experience</span> ho creato
                il percorso che avrei voluto trovare io:
              </p>
              <p className="italic text-white/70">zero fuffa, solo metodo, visione e strumenti per fare sul serio.</p>
              <p>
                Non vendo corsi. Accompagno chi fa impresa verso la propria autonomia digitale. Un passo alla volta,
                con competenza e consapevolezza.
              </p>
              <p className="text-white text-lg">
                Perché la vera trasformazione inizia quando <span className="text-lime">smetti di delegare il controllo</span>…
                e inizi a guidare tu.
              </p>
            </Reveal>

            <div className="mt-10 flex flex-wrap gap-8 pt-8 border-t border-white/10">
              <div>
                <div className="font-display text-3xl" style={{ color: "#6b8bff" }}>10+</div>
                <div className="text-white/50 text-xs mt-1 uppercase tracking-widest">Anni di agenzia</div>
              </div>
              <div>
                <div className="font-display text-3xl" style={{ color: "#6b8bff" }}>200+</div>
                <div className="text-white/50 text-xs mt-1 uppercase tracking-widest">PMI supportate</div>
              </div>
              <div>
                <div className="font-display text-3xl" style={{ color: "#6b8bff" }}>35h</div>
                <div className="text-white/50 text-xs mt-1 uppercase tracking-widest">Formazione dal vivo</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
